import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { jackpotHistoryListApi } from "store/actions";
import Table from "components/Table";
import Columns from "./Columns";
import FormikForm from "components/shared/FormikForm";
import JackpotHistoryModal from "components/Modals/JackpotHistory/JackpotHistoryModal";

const InputFieldsForSearch = [
  {
    name: "search",
    type: "text",
    label: "",
    placeholder: "Search...",
  },
];
const initialValuesForFilter = {
  search: "",
};

const List = ({ userDetails }) => {
  const dispatch = useDispatch();
  const [jackpotModalShow, setJackpotModalShow] = useState(false);
  const { jackpotHistoryList, loading, totalJackpotHistory } = useSelector(
    ({ Jackpot }) => Jackpot
  );
  const [columns, setcolumns] = useState([{ dataField: "", text: "" }]);
  const [id, setId] = useState(null);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 20,
    order: -1,
    orderBy: "date_created_utc",
    search: "",
    status: "All",
    userId: userDetails?._id,
  });

  useEffect(() => {
    if (userDetails?._id) {
      getApiData({ ...filter, userId: userDetails?._id });
      setcolumns(Columns({ handleEditHandler }));
    }
  }, [filter, userDetails]);

  async function getApiData(query) {
    try {
      dispatch(jackpotHistoryListApi({ data: query }));
    } catch (error) {}
  }

  const handleEditHandler = (info) => {
    setJackpotModalShow(true);
    setId(info?._id);
  };

  const handleFilterForm = (info) => {
    setFilter({
      ...filter,
      page: 1,
      limit: 20,
      order: -1,
      orderBy: "date_created_utc",
      search: info.search,
      status: info.status,
    });
  };

  return (
    <>
      <JackpotHistoryModal
        show={jackpotModalShow}
        handleClose={() => {
          setJackpotModalShow(false);
        }}
        title={"Jackpot Details"}
        id={id}
      />
      <div className="section-body">
        <div className="card">
          <div className="row justify-content-between">
            <div className="col-6">
              <div className="card-header">
                <h2 className="section-title">Jackpot History</h2>
              </div>
            </div>
            <div className="col-6">
              <div className="card-header d-flex justify-content-end align-items-center"></div>
            </div>
            <div className="col-12">
              <div className="card-header">
                <FormikForm
                  initialValues={initialValuesForFilter}
                  onSubmit={handleFilterForm}
                  loading={loading}
                  inputFields={InputFieldsForSearch}
                  buttonText={"Search"}
                />
              </div>
            </div>
          </div>
        </div>
        {jackpotHistoryList?.length > 0 && (
          <Table
            data={jackpotHistoryList}
            columns={columns}
            setFilter={setFilter}
            total={totalJackpotHistory}
            filter={filter}
          />
        )}
        {!loading && jackpotHistoryList?.length === 0 && (
          <p style={{ textAlign: "center" }}>No Record Found</p>
        )}
      </div>
    </>
  );
};

export default List;
